module.exports = __webpack_public_path__ + "static/connection-1d05f79c39250527097eb30b5f2a1161.gif";